import { useState } from "react";
import Sidebar from "./Sidebar";
import { useTheme } from "../../context/ThemeContext";
import { cn } from "../../lib/utils";

export default function DashboardLayout({ children, title, subtitle }) {
  const [collapsed, setCollapsed] = useState(false);
  const { theme } = useTheme();

  return (
    <div className={cn(
      "min-h-screen transition-colors duration-300",
      theme === 'dark' ? 'bg-[#011a3a]' : 'bg-[#f8fafc]'
    )}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      
      <main
        className={cn(
          "min-h-screen transition-all duration-300",
          collapsed ? "ml-20" : "ml-64"
        )}
      >
        {/* Header */}
        <header className={cn(
          "h-16 border-b flex items-center px-8",
          theme === 'dark' ? 'border-white/5' : 'border-slate-200'
        )}>
          <div>
            {title && (
              <h1 className={cn(
                "text-xl font-semibold",
                theme === 'dark' ? 'text-white' : 'text-[#011a3a]'
              )}>
                {title}
              </h1>
            )}
            {subtitle && (
              <p className={cn(
                "text-sm",
                theme === 'dark' ? 'text-slate-400' : 'text-slate-600'
              )}>
                {subtitle}
              </p>
            )}
          </div>
        </header>

        {/* Content */}
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
}
